const INITIAL_STATE = {
  data: {},
  errors: {},
}

const addNewCard = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'ADD_NEW_CARD':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'ADD_NEW_CARD_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default addNewCard;
